import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#474487",
    },
    secondary: {
      main: "#b0b3ff",
    },
  },

  typography: {
    allVariants: {
      // wordWrap: "break-word",
      // wordBreak: "break-word",
    },
  },
  shape: {
    borderRadius: 20,
  },

  components: {
    MuiListItemText: {
      styleOverrides: {
        primary: {
          // fontWeight: "bold",
          // fontSize: "15px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        sizeSmall: {
          fontSize: 11,
          paddingTop: "6px",
          paddingBottom: "6px",
        },
      },
    },
    MuiIcon: {
      defaultProps: {
        fontSize: "small",
      },
    },
  },
});
